export default "__VITE_ASSET__DZOybWdq__"